import { FuncionalidadeTipoInterface } from "../contracts/FuncionalidadeTipo.interface";

export class FuncionalidadeTipo implements FuncionalidadeTipoInterface {
  nomeConsultaApiBase = "funcionalidade-tipo";
  id: number;
  nmFuncionalidadeTipo: string;
  dsFuncionalidadeTipo: string;
}
